import { createContext } from 'react';

import Organisation from '~interfaces/organisation';

export interface OrganisationContextValue {
	isLoading: boolean;
	organisation: Organisation | undefined;
}

const OrganisationContext = createContext<OrganisationContextValue>({
	isLoading: true,
	organisation: undefined,
});

export default OrganisationContext;
